
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BetHistoryEntity, BetHistoryEntitySelection } from '@/common/api/model';
import { OrderType, TransactionType } from '@/common/config';
import { round } from '@/common/utils';
import FaCheckSquare from '@/components/icons/FaCheckSquare.vue';
import FaRegSquare from '@/components/icons/FaRegSquare.vue';
import MdRadioButtonChecked from '@/components/icons/MdRadioButtonChecked.vue';
import MdRadioButtonUnchecked from '@/components/icons/MdRadioButtonUnchecked.vue';
import ThemeButton from '@/components/ThemeButton.vue';

const userModule = namespace('user');
const chatModule = namespace('chat');
const getTitile = (firstSelection: BetHistoryEntitySelection) => {
  const isOutright = firstSelection.eventId.includes('match');
  return isOutright ? `${firstSelection.home} vs ${firstSelection.away}` : firstSelection.tournamentName;
};

@Component({
  components: {
    FaCheckSquare,
    FaRegSquare,
    MdRadioButtonChecked,
    MdRadioButtonUnchecked,
    ThemeButton,
  },
  filters: {
    formatDate (value: any) {
      const options = { hour12: false, month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    getTitile (firstSelection: BetHistoryEntitySelection) {
      return getTitile(firstSelection);
    },
  },
})
export default class BetItems extends Vue {
  @Prop({ default: () => ([]) }) readonly transactions!: BetHistoryEntity[];
  @Prop(Boolean) readonly viewOnly!: boolean;

  @userModule.Getter('currency') currency!: string;
  @chatModule.Mutation('updateExtraTransactionInfo') updateExtraTransactionInfo!: Function;

  winningStatusMap = {
    0: 'Running',
    5: 'Partial Win',
    20: 'Won',
    30: 'Lost',
    40: 'Void',
    90: 'Pending',
  };
  orderTypeMap = OrderType;
  selectedTransIssue: BetHistoryEntity[] = [];
  expandedTrans: string[] = [];
  actionType: string = 'Bet';
  submitted = false;

  isTransactionSelected (transaction: BetHistoryEntity) {
    return this.selectedTransIssue.includes(transaction);
  }

  toggleTransactionSelection (transaction: BetHistoryEntity) {
    if (this.submitted) return;
    if (this.selectedTransIssue.includes(transaction)) {
      this.selectedTransIssue = this.selectedTransIssue.filter(t => t !== transaction);
    } else {
      this.selectedTransIssue = [...this.selectedTransIssue, transaction];
    }
  }

  getTotalWinnings (trans: BetHistoryEntity) {
    const { winningStatus, totalWinnings } = trans;
    return winningStatus === 0 || winningStatus === 40 ? '--' : totalWinnings;
  }
  getReturnClass (trans: BetHistoryEntity) {
    const { winningStatus } = trans;
    if (winningStatus === 5 || winningStatus === 20) {
      return 'winnings';
    } else if (winningStatus === 30) {
      return 'losses';
    } else {
      return null;
    }
  }
  expandTrans (shortId: string) {
    const index = this.expandedTrans.indexOf(shortId);
    const exist = index !== -1;
    if (exist) {
      this.expandedTrans.splice(index, 1);
    } else {
      this.expandedTrans.push(shortId);
    }
  }
  calculateOdds (trans: BetHistoryEntity) {
    if (trans.orderType === 1 && trans.selections.length === 1) {
      return round(+trans.selections[0].odds, 2);
    } else if (trans.orderType === 2) {
      const val = trans.selections.reduce((acc: number, curr: BetHistoryEntitySelection) => {
        return acc * +curr.odds;
      }, 1);
      return round(val, 2);
    }
    return false;
  }

  proceed () {
    const selectedBetList = this.selectedTransIssue;
    if (!selectedBetList?.length || this.submitted) return;

    const issueMessages = selectedBetList.reduce((acc: string[], cur) => {
      const msg = `${OrderType[cur.orderType] || ''} ${this.actionType} (Id: ${cur.shortId})`;
      return [...acc, msg];
    }, []);
    this.$emit('input', { type: TransactionType.Bet, issueMessages, selected: selectedBetList });
    this.submitted = true;
  }
}
